const defaultTitle = 'Planos';

export const PAGE_TITLE = {
  defaultTitle,
  planLandingPage: (planName: string) => `${defaultTitle} | Plano ${planName}`,
  planStates: defaultTitle.concat(' | Seleção de área de cobertura'),
  catalog: (label: string) => `${defaultTitle} | Catálogo - ${label}`,
  details: (planName: string) =>
    planName
      ? `${defaultTitle} | ${planName} - Contratação de plano`
      : `${defaultTitle} - Contratação de plano`,
  holder: defaultTitle.concat(' | Cadastro de dados do titular'),
  holderRule: defaultTitle.concat(' | Regra de titular'),
  dependentRule: defaultTitle.concat(' | Regra de dependente'),
  dependentRuleGroup: defaultTitle.concat(' | Critério de dependente'),
  editHolderRule: defaultTitle.concat(' | Editar regra de titular'),
  holderAddress: defaultTitle.concat(' | Cadastro de endereço do titular'),
  dependents: defaultTitle.concat(' | Cadastro de dependentes'),
  paymentMethods: defaultTitle.concat(' | Cadastro de cartão de crédito'),
  mobilityInsurance: defaultTitle.concat(
    ' | Cadastro de mobilidade emergencial',
  ),
  success: defaultTitle.concat(' | Finalização de cadastro'),
  summary: defaultTitle.concat(' | Confirmação de cadastro'),
  couponsSave: (status: boolean) =>
    status
      ? defaultTitle.concat(' | Sucesso - Cupom aplicado')
      : defaultTitle.concat(' | Inválido - Cupom aplicado'),
};
